module.exports = __webpack_public_path__ + "img/011.7957a857.png";